import { makeStyles, Theme } from "@material-ui/core";
import clsx from "clsx";
import React, { ElementType, forwardRef, LegacyRef } from "react";
import TripleDots from "../TripleDots";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    fontSize: 16,
    height: 48,
    padding: "2px 16px",
    backgroundColor: "#f23c04",
    border: "none",
    borderRadius: 5,
    color: "#fff",
    cursor: "pointer",
    alignSelf: "center",
    fontFamily: "var(--heading-font)",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:disabled": {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none",
    },
    [theme.breakpoints.up("xs")]: {
      width: "100%",
    },
  },
  icon: {
    display: "flex",
  },
  iconHidden: {
    opacity: 0,
    visibility: "hidden",
  },
}));

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ElementType;
  loading?: boolean;
}

export const Button = forwardRef(
  ({ children, className, type = "button", icon: Icon, onClick, loading, disabled }: ButtonProps, ref) => {
    const classes = useStyles();

    return (
      <button
        className={clsx(classes.root, className)}
        type={type}
        onClick={onClick}
        ref={ref as LegacyRef<HTMLButtonElement>}
        disabled={disabled || loading}
      >
        <span className={classes.icon}>{!!Icon && <Icon />}</span>
        {loading ? <TripleDots /> : children}
        <span className={clsx(classes.icon, classes.iconHidden)}>{!!Icon && <Icon />}</span>
      </button>
    );
  }
);
